import React, { useState, useCallback, useId } from 'react';
import i18next from 'i18next';
import {
  List,
  Item,
  Header,
  Label,
  Heading,
  Indicator,
  IndicatorValue,
  Icon,
  Body,
} from './wrapper';
import { IconChevronDown } from '../Icon/index';

export interface IAccordionItem {
  heading: string;
  activeCount?: number;
  children: React.ReactNode;
  isActive?: boolean;
}

export interface IAccordion {
  children?: React.ReactNode;
}

export const AccordionItem = ({ heading, children, activeCount, isActive }: IAccordionItem) => {
  const [extend, setExtend] = useState(isActive || false);
  const onToggleExtend = useCallback(() => setExtend(!extend), [extend]);
  const bodyId = useId();

  return (
    <Item isOpen={extend}>
      <Header
        onClick={onToggleExtend}
        aria-expanded={extend}
        aria-controls={bodyId}
        title={i18next.t('common.showMore') || ''}
      >
        <Label>
          <Heading>{heading}</Heading>
          {activeCount && activeCount > 0 && (
            <Indicator>
              <IndicatorValue>{activeCount}</IndicatorValue>
            </Indicator>
          )}
        </Label>
        <Icon>
          <IconChevronDown block aria-hidden="true" />
        </Icon>
      </Header>
      <Body id={bodyId}>{children}</Body>
    </Item>
  );
};

const Accordion = ({ children }: IAccordion) => <List>{children}</List>;

export default Accordion;
